import {useInfiniteQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {GetFacesParams} from 'src/services/api/endpoints/FacialRecognitionEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

export default function useFaces(params: GetFacesParams) {
  const query = useInfiniteQuery({
    retry: 0,
    initialPageParam: 1,
    queryKey: [QueryKeyEnum.FACES, params],
    queryFn: async ({pageParam: nextPage}) => {
      if (nextPage === -1) throw new Error('No more pages to fetch')
      return await api.facialRecognition.getFaces({...params, page: nextPage})
    },
    getNextPageParam: (lastPage) => {
      const nextPage = lastPage.data.data.currentPage + 1
      const totalPages = lastPage.data.data.totalPages
      if (!totalPages || nextPage > totalPages) return -1
      return nextPage
    },
    throwOnError: () => {
      return false
    },
  })

  return query
}
